import { render, staticRenderFns } from "./TaxableRebateGroupSetupNew.vue?vue&type=template&id=070c937c"
import script from "./TaxableRebateGroupSetupNew.vue?vue&type=script&lang=js"
export * from "./TaxableRebateGroupSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports